/* ============
 * * Packaging Type Module Mutations
 * ============
 */

import { FETCH_PACKAGING_TYPES } from '../../mutation-types';

export default {
  [FETCH_PACKAGING_TYPES](state, packagingTypes) {
    state.all = packagingTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/packagingType/mutations.js